// Auctions — placeholder imagery until dedicated auction photography is uploaded.
// When the user drops final Auctions imagery, ONLY this file needs updating.
// Do not point any other collection module at these images.
import { EXTERIOR_PHOTOS, INTERIOR_PHOTOS } from "./_base";

// Placeholder library. Replace with real Auctions photography drop.
export const AUCTIONS_PHOTOS = [
  EXTERIOR_PHOTOS[1],   // black Prevost X3-45, palms — signature auction lot
  INTERIOR_PHOTOS[2],   // dark noir galley — hammer-time atmosphere
];

const auctions = {
  hero: EXTERIOR_PHOTOS[1],   // black Prevost X3-45, palms — signature auction lot
  accent: INTERIOR_PHOTOS[2], // dark noir galley — hammer-time atmosphere
  gallery: [INTERIOR_PHOTOS[2]],
  card: EXTERIOR_PHOTOS[1],
  social: EXTERIOR_PHOTOS[1],
};
export default auctions;
